import {SET_CAT_PRODUCT_FILTER} from "../actions/types";

const initialState = {
    group_id: null
};
const productFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CAT_PRODUCT_FILTER:
            return {...state, group_id: action.payload};
        default:
            return state;
    }
};

export default productFilterReducer;


